module.exports = __webpack_public_path__ + "img/map_img1.55135a51.png";